<template>
  <div class="tree">
    <div class="radish-act-grp">
      部门操作：
      <div class="radish-btn radish-btn-primary" @click="showDialog">合并</div>
      <div class="radish-btn radish-btn-primary" @click="chooseShowDepartment">全选已显示</div>
      <div class="radish-btn radish-btn-primary" @click="clearCheckedDepartment">清空已勾选</div>
    </div>
    <el-input
      v-model="filterText"
      placeholder="输入关键字进行搜索,搜索不影响已勾选部门"
      size="mini"
      @keyup.enter.native="toFilterText(filterText)"
    ></el-input>
    <el-tree
      ref="tree"
      class="flex-left-space overflow-auto"
      :data="tree"
      :props="defaultProps"
      node-key="_id"
      show-checkbox
      :expand-on-click-node="false"
      :default-expanded-keys="defaultExpandedKeys"
      :filter-node-method="filterNode"
    >
      <span slot-scope="{ node, data }">
        <span
          onselectstart="return false;"
          style="margin-right:5px;color:#409eff;"
          @dblclick="showDepartmentList(data)"
        >
          {{ data.名称 }}（{{ data.人数 }}）
        </span>
      </span>
    </el-tree>
    <!-- 合并部门弹窗 -->
    <el-dialog title="选择主要数据" :visible.sync="dialogVisible" :close-on-click-modal="false" :modal="false" width="300">
      <el-radio-group v-model="radio">
        <el-radio v-for="item in checkedDepartments" :key="item._id" :label="item._id"> {{ item.名称 }} </el-radio>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="dialogVisible = false">取 消</div>
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="confirmMerge">确 定</div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: { tree: { type: Array, default: () => [] }, nodes: { type: Array, default: () => [] } },
  data() {
    return {
      filterText: '',
      searchDepartmentName: '',
      defaultExpandedKeys: [],
      defaultProps: {
        children: 'children',
        label: '名称',
      },
      dialogVisible: false,
      radio: '',
      checkedDepartments: [],
    }
  },
  watch: {
    tree(newValue, oldValue) {
      if (newValue.length !== 0) {
        newValue[0].disabled = true
        this.defaultExpandedKeys = [newValue[0]._id]
      }
    },
  },
  async mounted() {
    await this.sleep(500)
  },
  methods: {
    async sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    chooseShowDepartment() {
      const { filterText, nodes } = this
      const hasCheckedDepartments = this.$refs.tree.getCheckedNodes()
      const checkedDepartments = nodes.filter(v => !v.disabled && v.pid !== v.公司 && v.名称.includes(filterText))
      checkedDepartments.forEach(v => {
        const flag = hasCheckedDepartments.find(val => val._id == v._id)
        if (!flag) hasCheckedDepartments.push(v)
      })
      this.$refs.tree.setCheckedNodes(hasCheckedDepartments)
    },
    clearCheckedDepartment() {
      this.checkedDepartments = []
      this.$refs.tree.setCheckedKeys([])
    },
    showDialog() {
      this.dialogVisible = true
      this.checkedDepartments = this.$refs.tree.getCheckedNodes().filter(v => v.pid !== v.公司)
    },
    async confirmMerge() {
      const first = this.radio
      if (!first) this.$message('请选择一个部门作为主要部门')
      const second = this.checkedDepartments.filter(v => v._id !== first).map(v => v._id)
      const res = await app.service('company').mergeDepartment({ first, second })
      if (res.status === 'success') {
        this.$emit('refresh')
        this.$message('合并成功')
      } else this.$message.error(res.msg)
      this.dialogVisible = false
    },
    toFilterText(val) {
      this.$refs.tree.filter(val)
    },
    filterNode(value, data) {
      if (!value) return true
      return data.名称.indexOf(value) !== -1
    },
    showDepartmentList(nodeData) {
      this.$emit('showDepartmentList', nodeData)
    },
    // toSearch() {},
    // clearSearch() {
    //   this.searchDepartmentName = ''
    // },
  },
}
</script>
<style src="../../statistics/css/companyOchart.css" scoped></style>
